// web-config.json can carry per-host overrides:
//   "HostOverrides": { "app-stage.upkeepr.com": { "UpkeeprApi.Uri": "https://api-stage.upkeepr.com/graphql/upkeepr" } }
// The staging slot and production serve the same build (a slot swap moves the files), so the
// staging host has to pick its own API from the page's host rather than from a different file.
export type WebConfig = Record<string, unknown> & {
  HostOverrides?: Record<string, Record<string, unknown>>;
};

export function applyHostOverrides(config: WebConfig, host: string): Record<string, unknown> {
  const { HostOverrides, ...rest } = config;
  const overrides = HostOverrides?.[host.toLowerCase()];
  return overrides ? { ...rest, ...overrides } : rest;
}
